// extracted by mini-css-extract-plugin
export default {"complete_area":"Complete_complete_area__kHOcW","contents":"Complete_contents__fyjbO","btn_wrapper":"Complete_btn_wrapper__DTA8F","contact_area":"Complete_contact_area__xlW31"};